/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar, Pie } from "react-chartjs-2";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
  Media,
  CardTitle,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import moment from "moment";
import ResellerItemReport from "./ResellerItemReport";

import { getAuthUserDetail } from "../../../services/BusinessFlow/UserService";

//data
import { ResellerTotalSUMReportAPI } from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";

const ResellerReport = (props) => {
  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [diaBalance, setDiaBalance] = useState(null);
  const [akhBalance, setAkhBalance] = useState(null);
  const [todayOrder, setTodayOrder] = useState(null);
  const [weeklyOrder, setWeeklyOrder] = useState(null);
  const [monthlyOrder, setMonthlyOrder] = useState(null);

  useEffect(() => {
    const today_start_date = moment().startOf("day").toISOString();
    const today_end_date = moment().endOf("day").toISOString();

    const weekly_start_date = moment().startOf("week").toISOString();
    const weekly_end_date = moment().endOf("week").toISOString();

    const monthly_start_date = moment().startOf("month").toISOString();
    const monthly_end_date = moment().endOf("month").toISOString();

    fetchUserDetail();
    fetchTotalOrder(today_start_date, today_end_date, setTodayOrder);
    fetchTotalOrder(weekly_start_date, weekly_end_date, setWeeklyOrder);
    fetchTotalOrder(monthly_start_date, monthly_end_date, setMonthlyOrder);
  }, []);

  let fetchUserDetail = () => {
    getAuthUserDetail()
      .then((res) => {
        console.log("fetchUserDetail", res);
        let total_dia = res.data?.wallets.find(
          (wallet) => wallet.currency == "SmileCoin"
        ).unit_amount;
        let total_akh_unit = res.data?.wallets.find(
          (wallet) => wallet.currency == "AKH-Coin"
        ).unit_amount;
        setDiaBalance(total_dia);
        setAkhBalance(total_akh_unit);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let fetchTotalOrder = (start_date, end_date, callBack) => {
    let url =
      ResellerTotalSUMReportAPI +
      `?start_date=${start_date}&end_date=${end_date}`;
    getApiDataService(url)
      .then((res) => {
        let data = res.data;
        callBack(data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        callBack(null);
      });
  };

  const formatNumber = (number) =>
    number
      ? number.toLocaleString("en-US", {
          maximimFractionDigits: 2,
          notation: "compact",
          compactDisplay: "short",
        })
      : 0;

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Balance
                        </CardTitle>

                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0"></span>
                          <span className="h4 font-weight-bold mb-0">
                            {diaBalance?.toLocaleString("en-US")} Diamonds
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">
                            
                          </span>
                          <span className="h4 font-weight-bold mb-0">{akhBalance?.toLocaleString("en-US")} AKH-Coin</span>
                        </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                          <i className="fa fa-coins" aria-hidden="true"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Today Order
                        </CardTitle>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Diamond -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {/* {formatNumber(1151)} */}
                            {todayOrder?.total_price?.toLocaleString("en-US")}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Qty -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {todayOrder?.order_count?.toLocaleString("en-US")}
                          </span>
                        </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fa fa-coins" aria-hidden="true"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Weekly Order
                        </CardTitle>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Diamond -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {/* {formatNumber(1151)} */}
                            {weeklyOrder?.total_price?.toLocaleString("en-US")}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Qty -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {weeklyOrder?.order_count?.toLocaleString("en-US")}
                          </span>
                        </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fa fa-coins" aria-hidden="true"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Monthly Order
                        </CardTitle>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Diamond -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {/* {formatNumber(1151)} */}
                            {monthlyOrder?.total_price?.toLocaleString("en-US")}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="h5 mr-2 mb-0">Qty -</span>
                          <span className="h4 font-weight-bold mb-0">
                            {monthlyOrder?.order_count?.toLocaleString("en-US")}
                          </span>
                        </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fa fa-coins" aria-hidden="true"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12" className="mt-0">
            <ResellerItemReport></ResellerItemReport>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ResellerReport;
